import React, { useState } from 'react';
import Card from '../components/common/Card';
import Badge from '../components/common/Badge';
import { Bell, Globe, Lock, Shield, User, Users, Database, Activity } from 'lucide-react';
const Settings = () => {
  const [activeTab, setActiveTab] = useState<'profile' | 'security' | 'access' | 'system'>('profile');
  return <div className="space-y-6" data-id="element-1092">
      <div className="flex items-center justify-between" data-id="element-1093">
        <div data-id="element-1094">
          <h1 className="text-2xl font-bold text-white" data-id="element-1095">
            Settings & Access Control
          </h1>
          <p className="text-sm text-gray-400 mt-1" data-id="element-1096">
            Kelola pengaturan sistem dan kontrol akses
          </p>
        </div>
        <div className="flex items-center px-2 py-1 bg-red-900/30 rounded text-xs text-red-400 border border-red-800/50" data-id="element-1097">
          <Lock className="h-3 w-3 mr-1" data-id="element-1098" />
          <span data-id="element-1099">ADMIN ACCESS REQUIRED</span>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-1100">
        {/* Sidebar Navigation */}
        <Card className="lg:col-span-1 p-4" data-id="element-1101">
          <nav className="space-y-1" data-id="element-1102">
            <button onClick={() => setActiveTab('profile')} className={`w-full flex items-center px-4 py-3 rounded-lg ${activeTab === 'profile' ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`} data-id="element-1103">
              <User className="h-5 w-5 mr-3" data-id="element-1104" />
              <span data-id="element-1105">Profile</span>
            </button>
            <button onClick={() => setActiveTab('security')} className={`w-full flex items-center px-4 py-3 rounded-lg ${activeTab === 'security' ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`} data-id="element-1106">
              <Shield className="h-5 w-5 mr-3" data-id="element-1107" />
              <span data-id="element-1108">Security</span>
            </button>
            <button onClick={() => setActiveTab('access')} className={`w-full flex items-center px-4 py-3 rounded-lg ${activeTab === 'access' ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`} data-id="element-1109">
              <Users className="h-5 w-5 mr-3" data-id="element-1110" />
              <span data-id="element-1111">User Access</span>
            </button>
            <button onClick={() => setActiveTab('system')} className={`w-full flex items-center px-4 py-3 rounded-lg ${activeTab === 'system' ? 'bg-gray-800 text-white' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}`} data-id="element-1112">
              <Database className="h-5 w-5 mr-3" data-id="element-1113" />
              <span data-id="element-1114">System</span>
            </button>
          </nav>
        </Card>
        {/* Main Content */}
        <div className="lg:col-span-3 space-y-6" data-id="element-1115">
          {activeTab === 'profile' && <>
              <Card className="p-6" data-id="element-1116">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1117">
                  Profile Information
                </h2>
                <div className="space-y-4" data-id="element-1118">
                  <div className="flex items-center space-x-4" data-id="element-1119">
                    <div className="w-20 h-20 rounded-full bg-gray-700 flex items-center justify-center text-white text-2xl font-semibold" data-id="element-1120">
                      K
                    </div>
                    <div data-id="element-1121">
                      <button className="px-4 py-2 bg-gray-800 hover:bg-gray-700 text-white rounded-lg text-sm" data-id="element-1122">
                        Change Photo
                      </button>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1123">
                    <div data-id="element-1124">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1125">
                        Full Name
                      </label>
                      <input type="text" defaultValue="Kepala BIN" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1126" />
                    </div>
                    <div data-id="element-1127">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1128">
                        Position
                      </label>
                      <input type="text" defaultValue="Kepala Badan Intelijen Negara" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1129" />
                    </div>
                    <div data-id="element-1130">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1131">
                        Email
                      </label>
                      <input type="email" defaultValue="kepala@bin.go.id" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1132" />
                    </div>
                    <div data-id="element-1133">
                      <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1134">
                        Phone
                      </label>
                      <input type="tel" defaultValue="+62 21 XXXX XXXX" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1135" />
                    </div>
                  </div>
                  <div className="flex justify-end" data-id="element-1136">
                    <button className="px-6 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg" data-id="element-1137">
                      Save Changes
                    </button>
                  </div>
                </div>
              </Card>
              <Card className="p-6" data-id="element-1138">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1139">
                  Notification Preferences
                </h2>
                <div className="space-y-4" data-id="element-1140">
                  <div className="flex items-center justify-between" data-id="element-1141">
                    <div className="flex items-center" data-id="element-1142">
                      <Bell className="h-5 w-5 text-gray-400 mr-3" data-id="element-1143" />
                      <div data-id="element-1144">
                        <p className="text-white" data-id="element-1145">Critical Alerts</p>
                        <p className="text-sm text-gray-400" data-id="element-1146">
                          Receive notifications for critical security alerts
                        </p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1147">
                      <input type="checkbox" defaultChecked className="sr-only peer" data-id="element-1148" />
                      <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600" data-id="element-1149"></div>
                    </label>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-1150">
                    <div className="flex items-center" data-id="element-1151">
                      <Globe className="h-5 w-5 text-gray-400 mr-3" data-id="element-1152" />
                      <div data-id="element-1153">
                        <p className="text-white" data-id="element-1154">Daily Brief</p>
                        <p className="text-sm text-gray-400" data-id="element-1155">
                          Receive daily intelligence briefing
                        </p>
                      </div>
                    </div>
                    <label className="relative inline-flex items-center cursor-pointer" data-id="element-1156">
                      <input type="checkbox" defaultChecked className="sr-only peer" data-id="element-1157" />
                      <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-cyan-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-cyan-600" data-id="element-1158"></div>
                    </label>
                  </div>
                </div>
              </Card>
            </>}
          {activeTab === 'security' && <>
              <Card className="p-6" data-id="element-1159">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1160">
                  Security Settings
                </h2>
                <div className="space-y-4" data-id="element-1161">
                  <div data-id="element-1162">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1163">
                      Current Password
                    </label>
                    <input type="password" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1164" />
                  </div>
                  <div data-id="element-1165">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1166">
                      New Password
                    </label>
                    <input type="password" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1167" />
                  </div>
                  <div data-id="element-1168">
                    <label className="block text-sm font-medium text-gray-300 mb-2" data-id="element-1169">
                      Confirm New Password
                    </label>
                    <input type="password" className="w-full px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white focus:outline-none focus:ring-1 focus:ring-cyan-500" data-id="element-1170" />
                  </div>
                  <div className="flex justify-end" data-id="element-1171">
                    <button className="px-6 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg" data-id="element-1172">
                      Update Password
                    </button>
                  </div>
                </div>
              </Card>
              <Card className="p-6" data-id="element-1173">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1174">
                  Two-Factor Authentication
                </h2>
                <div className="flex items-center justify-between p-4 bg-green-900/20 border border-green-800/50 rounded-lg" data-id="element-1175">
                  <div className="flex items-center" data-id="element-1176">
                    <Shield className="h-5 w-5 text-green-400 mr-3" data-id="element-1177" />
                    <div data-id="element-1178">
                      <p className="text-white" data-id="element-1179">2FA Enabled</p>
                      <p className="text-sm text-gray-400" data-id="element-1180">
                        Your account is protected with two-factor authentication
                      </p>
                    </div>
                  </div>
                  <Badge variant="green" data-id="element-1181">Active</Badge>
                </div>
                <div className="mt-4" data-id="element-1182">
                  <button className="px-4 py-2 bg-red-900/30 hover:bg-red-900/50 text-red-400 rounded-lg border border-red-800/50" data-id="element-1183">
                    Disable 2FA
                  </button>
                </div>
              </Card>
              <Card className="p-6" data-id="element-1184">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1185">
                  Active Sessions
                </h2>
                <div className="space-y-3" data-id="element-1186">
                  <div className="flex items-center justify-between p-4 bg-gray-800 rounded-lg" data-id="element-1187">
                    <div className="flex items-center" data-id="element-1188">
                      <Activity className="h-5 w-5 text-green-400 mr-3" data-id="element-1189" />
                      <div data-id="element-1190">
                        <p className="text-white" data-id="element-1191">Current Session</p>
                        <p className="text-sm text-gray-400" data-id="element-1192">
                          Jakarta, Indonesia • Chrome on Windows
                        </p>
                      </div>
                    </div>
                    <Badge variant="green" data-id="element-1193">Active</Badge>
                  </div>
                </div>
              </Card>
            </>}
          {activeTab === 'access' && <Card className="p-6" data-id="element-1194">
              <div className="flex items-center justify-between mb-4" data-id="element-1195">
                <h2 className="text-xl font-semibold text-white" data-id="element-1196">
                  User Access Management
                </h2>
                <button className="px-4 py-2 bg-cyan-600 hover:bg-cyan-700 text-white rounded-lg" data-id="element-1197">
                  Add New User
                </button>
              </div>
              <div className="overflow-x-auto" data-id="element-1198">
                <table className="w-full" data-id="element-1199">
                  <thead data-id="element-1200">
                    <tr className="bg-gray-800" data-id="element-1201">
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase" data-id="element-1202">
                        User
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase" data-id="element-1203">
                        Role
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase" data-id="element-1204">
                        Department
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase" data-id="element-1205">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase" data-id="element-1206">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-800" data-id="element-1207">
                    <tr className="hover:bg-gray-800/50" data-id="element-1208">
                      <td className="px-4 py-3" data-id="element-1209">
                        <div className="flex items-center" data-id="element-1210">
                          <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-white mr-3" data-id="element-1211">
                            K
                          </div>
                          <div data-id="element-1212">
                            <p className="text-white" data-id="element-1213">Kepala BIN</p>
                            <p className="text-sm text-gray-400" data-id="element-1214">
                              kepala@bin.go.id
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-white" data-id="element-1215">Administrator</td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-1216">Executive</td>
                      <td className="px-4 py-3" data-id="element-1217">
                        <Badge variant="green" data-id="element-1218">Active</Badge>
                      </td>
                      <td className="px-4 py-3" data-id="element-1219">
                        <button className="text-cyan-400 hover:text-cyan-300" data-id="element-1220">
                          Edit
                        </button>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-800/50" data-id="element-1221">
                      <td className="px-4 py-3" data-id="element-1222">
                        <div className="flex items-center" data-id="element-1223">
                          <div className="w-8 h-8 rounded-full bg-gray-700 flex items-center justify-center text-white mr-3" data-id="element-1224">
                            D2
                          </div>
                          <div data-id="element-1225">
                            <p className="text-white" data-id="element-1226">Deputi II</p>
                            <p className="text-sm text-gray-400" data-id="element-1227">
                              deputi2@bin.go.id
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-white" data-id="element-1228">Deputy</td>
                      <td className="px-4 py-3 text-gray-300" data-id="element-1229">Deputi II</td>
                      <td className="px-4 py-3" data-id="element-1230">
                        <Badge variant="green" data-id="element-1231">Active</Badge>
                      </td>
                      <td className="px-4 py-3" data-id="element-1232">
                        <button className="text-cyan-400 hover:text-cyan-300" data-id="element-1233">
                          Edit
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>}
          {activeTab === 'system' && <>
              <Card className="p-6" data-id="element-1234">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1235">
                  System Information
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1236">
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-1237">
                    <p className="text-sm text-gray-400" data-id="element-1238">System Version</p>
                    <p className="text-lg font-semibold text-white mt-1" data-id="element-1239">
                      NEXUS BIN v2.5.0
                    </p>
                  </div>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-1240">
                    <p className="text-sm text-gray-400" data-id="element-1241">Last Update</p>
                    <p className="text-lg font-semibold text-white mt-1" data-id="element-1242">
                      31 Aug 2023
                    </p>
                  </div>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-1243">
                    <p className="text-sm text-gray-400" data-id="element-1244">Database Status</p>
                    <div className="flex items-center mt-1" data-id="element-1245">
                      <div className="w-2 h-2 rounded-full bg-green-500 mr-2" data-id="element-1246"></div>
                      <p className="text-lg font-semibold text-white" data-id="element-1247">Online</p>
                    </div>
                  </div>
                  <div className="p-4 bg-gray-800 rounded-lg" data-id="element-1248">
                    <p className="text-sm text-gray-400" data-id="element-1249">Security Level</p>
                    <p className="text-lg font-semibold text-white mt-1" data-id="element-1250">
                      Maximum
                    </p>
                  </div>
                </div>
              </Card>
              <Card className="p-6" data-id="element-1251">
                <h2 className="text-xl font-semibold text-white mb-4" data-id="element-1252">
                  System Maintenance
                </h2>
                <div className="space-y-3" data-id="element-1253">
                  <button className="w-full flex items-center justify-between p-4 bg-gray-800 hover:bg-gray-700 rounded-lg" data-id="element-1254">
                    <div className="flex items-center" data-id="element-1255">
                      <Database className="h-5 w-5 text-gray-400 mr-3" data-id="element-1256" />
                      <span className="text-white" data-id="element-1257">Backup Database</span>
                    </div>
                    <span className="text-sm text-gray-400" data-id="element-1258">
                      Last: 2 hours ago
                    </span>
                  </button>
                  <button className="w-full flex items-center justify-between p-4 bg-gray-800 hover:bg-gray-700 rounded-lg" data-id="element-1259">
                    <div className="flex items-center" data-id="element-1260">
                      <Activity className="h-5 w-5 text-gray-400 mr-3" data-id="element-1261" />
                      <span className="text-white" data-id="element-1262">System Logs</span>
                    </div>
                    <span className="text-sm text-gray-400" data-id="element-1263">View</span>
                  </button>
                </div>
              </Card>
            </>}
        </div>
      </div>
    </div>;
};
export default Settings;